<template>
  <div>
    <overlay :value="loading"></overlay>
    <v-card class="pa-6">
      <v-card-title class="text-uppercase">
        <v-row class="my-1 justify-space-between align-center">
          <div>{{ this.serviceType === null ? 'Crear nuevo' : 'Editar' }} tipo de servicio</div>
        </v-row>
      </v-card-title>
      <hr class="my-3" />
      <v-card-text class="my-0 py-0">
        <v-form ref="newServiceTypeForm" v-model="formValid">
          <v-container class="ma-0 pa-0">
            <v-col class="ma-0 pa-0">
              <v-row class="mt-1 mb-n5">
                <v-col cols="12">
                  <v-text-field
                    label="Nombre"
                    v-model="newServiceType.name"
                    required
                    outlined
                    dense
                    :rules="nameRules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="my-1">
                <v-col cols="12">
                  <div class="text-caption grey--text mb-2">Documentos requeridos</div>
                  <v-card outlined :loading="loadingAttachmentTypes">
                    <v-list dense style="max-height: 260px; overflow-y: auto;">
                      <v-list-item v-for="attachmentType in attachmentTypes" :key="attachmentType.id" class="px-2">
                        <v-checkbox
                          :input-value="isAttachmentSelected(attachmentType.id)"
                          :label="attachmentType.name"
                          hide-details
                          dense
                          class="mt-0 pt-0"
                          @change="toggleAttachment(attachmentType.id, $event)"
                        ></v-checkbox>
                      </v-list-item>
                      <v-list-item v-if="!loadingAttachmentTypes && attachmentTypes.length === 0">
                        <span class="grey--text text-caption">No hay tipos de adjunto disponibles</span>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-container>
        </v-form>
      </v-card-text>
      <hr class="my-3" />
      <v-card-actions class="justify-end">
        <v-btn text color="primary" rounded @click="closeDialog">Cerrar</v-btn>
        <v-btn :disabled="!formValid" color="primary" rounded @click="validate">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="error" :timeout="5000">
      Ocurrió un error guardando el tipo de servicio, intenta más tarde

      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="error = false"> Entendido </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Overlay from '../components/Overlay.vue';
import ServicesService from '../services/services.service';
import AttachmentTypesService from '../services/attachment-types.service';

export default {
  components: { Overlay },
  name: 'ServiceTypeMaintainer',
  props: ['serviceType'],
  data() {
    return {
      loading: false,
      loadingAttachmentTypes: false,
      error: false,
      newServiceType: {},
      attachmentTypes: [],
      formValid: false,
      nameRules: [v => !!v || 'El campo es requerido']
    };
  },
  mounted() {
    this.newServiceType = {};
    this.fetchAttachmentTypes();
    this.parseServiceType(this.serviceType !== null);
  },
  watch: {
    serviceType(val) {
      this.newServiceType = {};
      this.$refs.newServiceTypeForm.resetValidation();
      this.parseServiceType(val !== null);
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close-dialog');
    },
    isAttachmentSelected(id) {
      return (this.newServiceType.requiredAttachmentTypeIds || []).includes(id);
    },
    toggleAttachment(id, checked) {
      const current = this.newServiceType.requiredAttachmentTypeIds || [];
      this.newServiceType.requiredAttachmentTypeIds = checked
        ? current.includes(id)
          ? current
          : [...current, id]
        : current.filter(attachmentId => attachmentId !== id);
    },
    async fetchAttachmentTypes() {
      this.loadingAttachmentTypes = true;
      const res = await AttachmentTypesService.getAll();
      if (res.status === 'ok') this.attachmentTypes = res.data;
      this.loadingAttachmentTypes = false;
    },
    parseServiceType(exist) {
      this.newServiceType.id = exist ? this.serviceType.id : null;
      this.newServiceType.name = exist ? this.serviceType.name : '';
      this.newServiceType.requiredAttachmentTypeIds = exist
        ? (this.serviceType.requiredAttachments || []).map(a => a.id)
        : [];
      this.$nextTick(() => {
        if (this.$refs.newServiceTypeForm) this.$refs.newServiceTypeForm.validate();
      });
    },
    validate() {
      if (this.$refs.newServiceTypeForm.validate()) {
        if (this.serviceType === null) {
          this.createServiceType();
        } else {
          this.updateServiceType();
        }
      }
    },
    buildPayload() {
      return {
        name: this.newServiceType.name,
        requiredAttachmentTypeIds: this.newServiceType.requiredAttachmentTypeIds || []
      };
    },
    async createServiceType() {
      this.loading = true;
      const res = await ServicesService.createServiceType(this.buildPayload());
      this.loading = false;
      if (res.status === 'ok') {
        this.$refs.newServiceTypeForm.resetValidation();
        // Se emite el tipo recién creado para que quien abrió este diálogo
        // (p. ej. ServiceMaintainer, US4) pueda seleccionarlo automáticamente.
        this.$emit('update-list', res.data);
        this.closeDialog();
      } else {
        this.error = true;
      }
    },
    async updateServiceType() {
      this.loading = true;
      const res = await ServicesService.updateServiceType(this.newServiceType.id, this.buildPayload());
      this.loading = false;
      if (res.status === 'ok') {
        this.$refs.newServiceTypeForm.resetValidation();
        this.$emit('update-list', res.data);
        this.closeDialog();
      } else {
        this.error = true;
      }
    }
  }
};
</script>
